import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b17af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-info-detail" }
const _hoisted_2 = { class: "book-date" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "탑승일", -1 /* HOISTED */))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "seat-number"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "좌석", -1 /* HOISTED */))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "seat-info" }, " App의 좌석위치와 실제 버스의 좌석위치가 다를 수 있습니다. App에서 안내된 좌석위치에 탑승하여 주시기 바랍니다. ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString($setup.formatDay($props.boardDate)), 1 /* TEXT */)
    ]),
    ($props.seatAssignYn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString($props.seatNo), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.seatAssignYn && $setup.seatsInfosList?.[$setup.mySeatFloor - 1]?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode($setup["SeatsLayout"], {
            currentFloor: $setup.mySeatFloor,
            totalFloor: $setup.seatsInfosList.length,
            seatsInfo: $setup.seatsInfosList[$setup.mySeatFloor - 1],
            numberOfRows: $setup.seatsRowsNumList?.[$setup.mySeatFloor - 1],
            numberOfColumns: $setup.seatsColumnsNumList?.[$setup.mySeatFloor - 1],
            mySeatNo: $props.seatNo
          }, null, 8 /* PROPS */, ["currentFloor", "totalFloor", "seatsInfo", "numberOfRows", "numberOfColumns", "mySeatNo"]),
          _hoisted_9
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}